/* eslint-disable curly */
import React, { useRef, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  StatusBar,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { parseISO, format } from "date-fns";

import styles from "./styles";
import { validarDataNascimento } from "../../../services/aluno-service";
import ButtonConfirm from "../../../components/ButtonConfirm";
import Loading from "../../../components/Loading";
import { TextInputMask } from "react-native-masked-text";
import { onSignIn, setAluno } from "../../../services/auth-service";
import { alert } from "../../../utils/alerts";

function ValidarAnoNasc({ navigation }) {
  const inputData = useRef();

  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");

  const validado = () => {
    if (!data) {
      alert("Ops...", "Preencha a data");
      return false;
    }
    return true;
  };

  const validarData = async () => {
    if (!validado()) return;

    // setLoading(true);
    let aluno = navigation.getParam("aluno");

    try {
      const response = await validarDataNascimento(
        aluno.cpf,
        format(inputData.current.getRawValue(), "yyyy-MM-dd")
      );

      if (!response.ok) {
        setLoading(false);

        return alert("Ops...", "Data de nascimento incorreta");
      }

      const retornoApi = await response.json();

      onSignIn(retornoApi);

      setLoading(false);

      navigation.navigate("SemTelefoneVerificado");
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const handlerData = (e) => {
    setData(e);
    if (e.length === 10 && inputData.current.isValid())
      setConfirmDisabled(false);
    else {
      setConfirmDisabled(true);
    }
  };
  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.OS === "ios" ? "padding" : "null"}
        enabled
      >
        <ImageBackground
          source={require("../../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={styles.containerForm}>
            <TouchableOpacity
              style={styles.iconClose}
              onPress={() => {
                // StatusBar.setBackgroundColor("#F00");
                navigation.pop(1);
              }}
            >
              <Icon name={"close"} size={30} color="#FFF" />
            </TouchableOpacity>
            <Text style={styles.textHeader1}>
              Ok, só para termos certeza que é você
            </Text>
            <Text style={styles.textHeader2}>
              Informe sua data de nascimento:
            </Text>
            <TextInputMask
              type="datetime"
              options={{
                format: "DD/MM/YYYY",
              }}
              autoFocus={true}
              style={[styles.input, { textAlign: "center" }]}
              ref={inputData}
              placeholder="12/03/2000"
              keyboardType="phone-pad"
              placeholderTextColor="#ccc"
              value={data}
              onChangeText={handlerData}
              // onSubmitEditing={() => {
              //   buscar();
              // }}
            />
            <ButtonConfirm
              text="Continuar"
              disabled={confirmDisabled}
              onPress={validarData}
              msgDisabled="Por favor, preencha a data"
            />
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
}

export default ValidarAnoNasc;
